import { createContext } from "react";
import { Route, Routes } from "react-router-dom";
import { VipEvaluate } from "../../modules/vipEvaluate/components/VipEvaluate";

const VipEvaluateContext = createContext();

const VipEvaluateWrapper = () => {
  const value = {};

  return (
    <VipEvaluateContext.Provider value={value}>
      <Routes>
        <Route path="" element={<VipEvaluate />} />
      </Routes>
    </VipEvaluateContext.Provider>
  );
};

export { VipEvaluateWrapper };
